import React from 'react';
import Skeleton from 'components/Skeleton';
import { StyledCard } from '../LearnerHome.styles';

interface UpdateItem {
  id: string | number;
  message: string;
}

interface UpdatesCardProps {
  loading: boolean;
  updates?: UpdateItem[];
}

const UpdatesCard: React.FC<UpdatesCardProps> = ({ loading, updates }) => {
  if (loading) {
    return <Skeleton type='update-card' container={StyledCard} />;
  }

  if (!updates || updates.length === 0) {
    return <StyledCard>No updates available.</StyledCard>;
  }

  return (
    <StyledCard>
      <h3>Important Updates</h3>
      <ul>
        {updates.map((update) => (
          <li key={update.id}>{update.message}</li>
        ))}
      </ul>
    </StyledCard>
  );
};

export default UpdatesCard;
